const menuData = {
    starters: [
      {
        image: "/bruchetta.svg",
        name: "Bruschetta",
        price: "8.99",
        description: "Grilled bread topped with garlic, salt, olive oil, and fresh tomatoes."
      },
      {
        image: "https://www.budgetbytes.com/wp-content/uploads/2022/06/Loaded-Hummus-Pita-close.jpg",
        name: "Hummus with Pita",
        price: "6.99",
        description: "Smooth hummus served with warm pita bread for dipping."
      },
      {
        name: "Tzatziki",
        price: "6.99",
        image: "https://ohsweetbasil.com/wp-content/uploads/homemade-greek-tzatziki-recipe-2-scaled.jpg",
        description: "A creamy cucumber and garlic yogurt dip served with grilled pita wedges."
      },
      {
        name: "Taramasalata",
        price: "8.99",
        image: "https://images.immediate.co.uk/production/volatile/sites/30/2022/04/Taramasalata-40cb1a2.jpg?quality=90&resize=556,505",
        description: "A rich and creamy fish roe dip, served with fresh bread."
      }
    ],
    mainCourses: [
      {
        image: "/96de1a8e84d5b60e17f4e8a752e3825e17a622bf.jpg",
        name: "Grilled Fish",
        price: "19.99",
        description: "Fresh fish grilled to perfection, served with a side of lemon and olive oil."
      },
      {
        image: "/5b33e9cd6067eb9aa7ce588a24f8a5d73bf37ee0.jpg",
        name: "Mediterranean Pasta",
        price: "14.99",
        description: "A mix of pasta with olives, feta cheese, sun-dried tomatoes, and a light garlic sauce."
      },
      {
        name: "Falafel Pita with Tahini Sauce",
        price: "11.99",
        image: "https://www.cucinabyelena.com/wp-content/uploads/2024/03/Best-Falafel-Pita-Sandwich-Recipe-32-600x800.jpg",
        description: "Crispy falafel wrapped in warm pita bread with fresh vegetables and drizzled with tahini sauce."
      },
      {
        name: "Souvlaki",
        price: "13.99",
        // image: "https://littlesunnykitchen.com/wp-content/uploads/2023/07/Chicken-Souvlaki-Recipe-1.jpg",
        image: "https://creativescookery.com/wp-content/uploads/2024/06/Authentic-Greek-Chicken-Souvlaki-Recipe-1.jpeg",
        description: "Grilled skewers of marinated meat served with tzatziki, pita, and a fresh salad."
      },
      {
        name: "Moussaka",
        price: "14.99",
        image: "https://www.mygreekodyssey.com/wp-content/uploads/2020/02/6f0a1285-f83c-4413-997b-cb45e7e4d3ac-1.jpg",
        description: "Layers of eggplant, potatoes, minced beef, and béchamel sauce baked to perfection."
      },
      {
        name: "Hummus Layered Dip",
        price: "7.99",
        image: "https://www.savingdessert.com/wp-content/uploads/2019/03/Greek-Layered-Hummus-Dip-1.jpg",
        description: "A delicious blend of hummus, roasted red peppers, olives, and herbs served with warm pita."
      }
    ],
    desserts: [
      {
        image: "https://www.lemonblossoms.com/wp-content/uploads/2022/08/Baklaka-Recipe-S1.jpg",
        name: "Baklava",
        price: "5.99",
        description: "A rich, sweet pastry made of layers of filo, filled with nuts and sweet syrup."
      },
      {
        image: "/lemon-dessert.jpg",
        name: "Lemon Dessert",
        price: "7.99",
        description: "A tangy lemon dessert made from a recipe passed down through generations."
      },
      {
        name: "Yogurt with Honey and Walnut",
        price: "5.99",
        image: "https://www.mygreekdish.com/wp-content/uploads/2014/09/Greek-Yogurt-drizzled-with-Honey-and-Walnuts-Yiaourti-me-meli.jpg",
        description: "Creamy Greek yogurt topped with honey, walnuts, and seasonal fruits."
      }
    ]
  };
  
  export default menuData;
  